var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dropdown-content"}},[(_vm.active)?_c('div',{staticClass:"origin-top-right absolute right-0 mt-2 w-48 bg-white rounded-lg border py-2 content-dropdown"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }